var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _c("div", [_c("h1", [_vm._v(_vm._s(_vm.title))])]),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onClose.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _vm.isTypeApplicant
              ? _c("ApplicantSendOff", {
                  attrs: {
                    "is-anonymous": !_vm.customerIsDefined,
                    customer: _vm.customer
                  },
                  model: {
                    value: _vm.applicantSendOffData,
                    callback: function($$v) {
                      _vm.applicantSendOffData = $$v
                    },
                    expression: "applicantSendOffData"
                  }
                })
              : _c("CustomerSendOff", {
                  attrs: {
                    "disclosed-data": _vm.disclosedData,
                    pseudonym: _vm.pseudonym
                  },
                  model: {
                    value: _vm.customerSendOffData,
                    callback: function($$v) {
                      _vm.customerSendOffData = $$v
                    },
                    expression: "customerSendOffData"
                  }
                })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _c("Button", {
              staticClass: "mt-2",
              attrs: {
                text: "Jetzt verabschieden",
                icon: "checkmark",
                disabled: !_vm.sendOffDataValid || _vm.sendingRequest,
                loading: _vm.sendingRequest
              },
              on: { click: _vm.executeSendOff }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }